<ng-container *ngIf="!isDeleted">
  <app-user-avatar [user]="reply.userProfile" [size]="28"></app-user-avatar>
  <div class="post-reply">
    <div class="post-reply_content">
      <div class="post-reply_content-author">
        <span routerLink="/user-profile/user/{{ reply.userProfile.id }}"
          class="p4 post-reply_content-author_name">{{reply.userProfile.userName}}</span>
        <span class="post-reply_content-author_date">•</span>
        <span 
          class="p5 post-reply_content-author_date" 
          title="{{reply.created | formattedDate}}"
        >{{reply.created | relativeDate }}</span>
      </div>
      <div class="post-reply_content-reply">
        <p class="p3" style="margin: 0;">{{reply.replyText}}</p>
      </div>

      <app-likes-panel 
        [isComments]="true"
        [likesCount]="reply.likesCount"
        [lastLikedUser]="reply.lastLikeUserProfile"
        [contentId]="reply.id"
      ></app-likes-panel>
    </div>
    <app-button 
      [size]="'small'" 
      class="post-reply_action"
      [icon]="reply.isLiked ? 'heart-filled' : 'heart-outline'"
      (click)="toggleLikeReply()"
    ></app-button>
    <app-popup-menu
      *ngIf="isAdmin"  
      class="post-reply_action"
    >
      <app-button
        icon="trash-outline" 
        size="small" 
        title="Delete comment"
        [style]="'link'"
        (click)="deleteReply($event,reply.id)"
      ></app-button>
    </app-popup-menu>
  </div>
</ng-container>

<div class="d-flex py-5 px-5" *ngIf="isDeleted">
  <div style="text-align: center;"><p> This reply has been deleted! </p></div>
</div>
